import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-cinema-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">精选内容</h2>
          <p className="text-sm text-cinema-muted">编辑精选 · 深度好文 · 行业观察</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((card, i) => (
            <a
              key={i}
              href="#media"
              className="group bg-cinema-card hover:bg-cinema-card-hover border border-cinema-border hover:border-cinema-gold/20 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.coverUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${card.tagClass} whitespace-nowrap`}>{card.tag}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-white group-hover:text-cinema-gold transition-colors mb-2 line-clamp-2">{card.title}</h3>
                <p className="text-xs text-cinema-muted leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}